export enum TrialActionTypes {
  ACCEPT_TRAIL = 'accept/trail',
}
